import React, { useEffect, useState } from "react";
import { Menu, Button, MenuProps, Input, Modal, Tabs, Select, message, notification, Row, Col, Spin } from 'antd';
import { useNavigate, useLocation } from "react-router-dom";
import Header from '../common/header'
import testProfile from "../common/helpers/test-profile";

const tableHeaderStyle = { fontSize: 16, borderTop: "1px solid #cccccc", borderBottom: "1px solid #cccccc", color: "white", textAlign: "left", paddingLeft: 20 }
const tableRowStyle = { fontSize: 16, paddingTop: 10, color: "white", textAlign: "left", paddingLeft: 20 }

const Balance = ({ selectedBot, setDisplayBalanceSection, botState }) => {
    // const selectedBot = location.state;
    console.log({
        selectedBot
    })
    const orders = JSON.parse(localStorage.getItem(`orders`))?.strategies;
    const [assets, setAssets] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!selectedBot) return;
        setLoading(true);
        testProfile(selectedBot.host).then(res => {
            delete res.info

            let newArr = [];
            let hasTotal = false;
            Object.keys(res).forEach(key => {
                if (res?.[key]?.hasOwnProperty('total')) {
                    hasTotal = true;
                    newArr.push({ key, total: res?.[key]?.total })
                }
            })
            if (!hasTotal) {
                setAssets(res);
            } else {
                setAssets(newArr);
            }

            setLoading(false);
        }).catch(err => {
            console.log({ err })
            setLoading(false);
        })
    }, [selectedBot])

    const checkInTrade = (asset) => {
        try {
            let inTrade = 'No';
            orders.filter(order => order?.bot_id === selectedBot.id).forEach(order => {
                if (order?.symbol?.includes(asset?.key)) {
                    if (order?.logs && order.logs.length > 0) {
                        if (order.logs[order.logs.length - 1]?.order_status === 'open' && botState === 'play') {
                            inTrade = "Yes";
                        }
                    }
                }
            })
            return inTrade;
        } catch (err) {
            return 'No'
        }

    }
    return (
        <>
            <div style={{ height: "90%" }}>
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", padding: 15 }}>
                    <div style={{}}>
                        <div onClick={() => { setDisplayBalanceSection(false); }} style={{ display: "flex", cursor: "pointer", flexDirection: "row", gap: 10 }}>
                            <div style={{ color: "grey", fontSize: 17, textDecoration: "underline" }}>My bot list {'>'} Advanced {'>'} </div>
                            <div style={{ position: "relative", top: 3 }}>
                                <div style={{ color: "white" }}>{selectedBot.name} {'>'} Balances</div>
                                <div style={{ fontSize: 13, color: "grey" }} >{selectedBot.description || '-'}</div>
                            </div>

                        </div>

                        {/* <div style={{ color: "white", fontSize: 17 }}><span style={{ cursor: "pointer" }} onClick={() => { setDisplayBalanceSection(false); }}>Exchange API profiles {'>'} {selectedBot.name}</span> {'>'} Balances </div> */}
                    </div>
                </div>
                <div style={{ display: "flex", flexDirection: "row", height: "70%", width: "100%", padding: 10 }}>
                    <div style={{ display: "flex", flexDirection: "column", borderRadius: 5, width: "100%" }}>
                        <div style={{ overflowY: "auto" }}>
                            {loading ? <Spin size="large" style={{ marginLeft: 20 }} /> : <table style={{ width: "100%", }}>
                                <tr>
                                    <th style={tableHeaderStyle} >ASSET</th>
                                    <th style={tableHeaderStyle} >INFO</th>
                                    <th style={tableHeaderStyle} >IN TRADE</th>
                                    <th style={tableHeaderStyle} ></th>
                                    <th style={tableHeaderStyle} ></th>
                                </tr>
                                {assets && Array.isArray(assets) ?
                                    assets.sort((a, b) => b.total - a.total).map(data => {
                                        return <tr>
                                            <td style={tableRowStyle}>{data.key}</td>
                                            <td style={tableRowStyle}>{data.total}</td>
                                            <td style={tableRowStyle}>{checkInTrade(data)}</td>
                                            <td style={tableRowStyle}></td>
                                            <td style={tableRowStyle}></td>
                                        </tr>
                                    }
                                    )
                                    : assets &&
                                    Object.keys(assets).map(key => {
                                        return <tr>
                                            <td style={tableRowStyle}>{key}</td>
                                            <td style={tableRowStyle}>{JSON.stringify(assets[key])}</td>
                                            <td style={tableRowStyle}>0</td>
                                            <td style={tableRowStyle}></td>
                                            <td style={tableRowStyle}></td>
                                        </tr>
                                    }
                                    )}
                                {/* {assets.map(data => {
                                    return <tr>
                                        <td style={tableRowStyle}><div>{data.asset}</div></td>
                                        <td style={tableRowStyle}>{data.walletBalance}</td>
                                        <td style={tableRowStyle}>0</td>
                                        <td style={tableRowStyle}></td>
                                        <td style={tableRowStyle}></td>
                                    </tr>
                                })} */}
                            </table>}

                        </div>

                    </div>
                </div>
            </div>
            <div>
            </div>
        </>
    );
};

export default Balance;